import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRoute } from 'util/withRoute';

// Import Actions
import {
  fetchHomePageData,
} from '../../AppActions';

import {
  getAuthenticatedState, getHomePage,
} from '../../AppReducer';
import FAQ from './components/FAQ';
import { Navigate } from 'react-router';
import LoginPage from '../LoginPage/LoginPage';



class HomePage extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.dispatch(fetchHomePageData());
    if (this.props.isAuthenticated) {
      this.props.navigate('/dashboard')
    }
  }

  componentDidUpdate() {
    if (this.props.isAuthenticated) {
      this.props.navigate('/dashboard')
    }
  }

  render() {

    return (
      <div style={{ position: 'relative', display: 'flex', width: '100%' }}>
        <div style={{ backgroundColor: '#fff', width: '100%' }}>
          <LoginPage
            isAuthenticated={this.props.isAuthenticated}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    homepage: getHomePage(state),
    isAuthenticated: getAuthenticatedState(state),
  };
}

HomePage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  router: PropTypes.object,
};



export default connect(mapStateToProps)(withRoute(HomePage));
